import React from "react";
import { Image } from "@catchoftheday/cg-components";
import { ASSET_UPSELL_BOX_BG_WATERMARK_DESKTOP, ASSET_UPSELL_BOX_BG_WATERMARK_MOBILE } from "../../../consts";
import { useIsMobile } from "../../../hooks";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var OnePassBackgroundWatermark = function OnePassBackgroundWatermark() {
  var isMobile = useIsMobile();
  return ___EmotionJSX(Image, {
    src: isMobile ? ASSET_UPSELL_BOX_BG_WATERMARK_MOBILE : ASSET_UPSELL_BOX_BG_WATERMARK_DESKTOP,
    style: {
      pointerEvents: "none"
    },
    alt: "OnePass watermark background",
    position: "absolute",
    right: 0,
    bottom: 0,
    height: {
      xs: "auto",
      md: "100%"
    },
    width: {
      xs: "100%",
      md: "auto"
    }
  });
};